import styled from '@emotion/styled';

const Container = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 16px;
  background-color: #f0f0f3;
  border-radius: 8px;
  text-decoration: none;
  position: relative;
  cursor: pointer;
`;

const BannerText = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.04em;
  color: #1c2024;
`;

const AdLabel = styled.span`
  position: absolute;
  left: 12px;
  top: 16px;
  font-weight: 700;
  font-size: 12px;
  line-height: 2;
  letter-spacing: -0.04em;
  color: #b9bbc6;
`;

function ArrowIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line
        x1="1.75"
        y1="10"
        x2="19.25"
        y2="10"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <polyline
        points="15.75,6.67 19.25,10 15.75,13.33"
        stroke="#000000"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface GroupPurchaseBannerProps {
  utmMedium?: string;
  utmCampaign?: string;
  utmContent: string;
}

export function GroupPurchaseBanner({ utmMedium = 'button', utmCampaign, utmContent }: GroupPurchaseBannerProps) {
  const params = new URLSearchParams();
  params.set('utm_source', 'market');
  params.set('utm_medium', utmMedium);
  if (utmCampaign) params.set('utm_campaign', utmCampaign);
  params.set('utm_content', utmContent);

  const url = `https://ooye.kr?${params.toString()}`;

  return (
    <Container href={url} target="_blank" rel="noopener noreferrer">
      <AdLabel>AD</AdLabel>
      <BannerText>다른 공동구매 찾아보기</BannerText>
      <ArrowIcon />
    </Container>
  );
}
